import { cn } from '@/lib/utils';
import { cva } from 'class-variance-authority';
import { Separator } from '@/components/ui/separator';

export const lineWithDotVariants = cva('after:absolute after:rounded-full', {
  variants: {
    position: {
      default: 'absolute -left-[102vw] w-screen',
      relative: 'relative'
    },
    variant: {
      primary: 'after:bg-primary bg-primary [--line-bg:hsl(var(--primary))]',
      secondary: 'after:bg-secondary bg-secondary [--line-bg:hsl(var(--secondary))]',
      background: 'after:bg-background bg-background [--line-bg:hsl(var(--background))]'
    },
    placement: {
      default: 'left-0',
      top: 'top-7',
      center: 'top-1/2'
    },
    orientation: {
      default: 'after:right-0 after:top-1/2 after:-translate-y-1/2 [--line-deg:-90deg]',
      vertical: 'w-px h-auto min-h-20 after:-right-1/2 after:translate-x-[calc(50%-1px)] top-0 [--line-deg:180deg]'
    },
    size: {
      default: 'after:size-2',
      sm: 'after:size-3'
    }
  },
  defaultVariants: {
    variant: 'primary',
    placement: 'center',
    position: 'default',
    orientation: 'default',
    size: 'default'
  }
});

export default function LineWithDot({
  variant,
  placement = 'center',
  position,
  orientation,
  size,
  className,
  withGradient = false,
  ...rest
}) {
  const style = withGradient
    ? {
        ...rest.style,
        background: 'linear-gradient(var(--line-deg), var(--line-bg) 0%, rgba(0, 244, 161, 0) 100%)'
      }
    : rest.style;

  return (
    <Separator
      className={cn(
        'line-with-dots',
        lineWithDotVariants({
          variant,
          placement,
          position,
          orientation,
          size,
          className
        })
      )}
      {...rest}
      style={style}
    />
  );
}
